import React from 'react';
import LoadingButton from '@/components/ui/LoadingButton';

export type BulkActionBarProps = {
  selectedCount: number;
  totalFiltered?: number;
  totalAll?: number;
  onClear: () => void;
  onSelectPage?: () => void;
  onSelectFiltered?: () => void;
  onSelectAll?: () => void;
  loading?: boolean;
  children?: React.ReactNode;
  className?: string;
};

export default function BulkActionBar({
  selectedCount,
  totalFiltered,
  totalAll,
  onClear,
  onSelectPage,
  onSelectFiltered,
  onSelectAll,
  loading = false,
  children,
  className = '',
}: BulkActionBarProps) {
  if (selectedCount === 0 && !children) return null;

  return (
    <div
      className={['bulk-action-bar', selectedCount > 0 ? 'bulk-action-bar--active' : '', className]
        .filter(Boolean)
        .join(' ')}
      role="region"
      aria-label="Bulk actions"
    >
      <div className="bulk-action-bar__meta">
        {selectedCount > 0 ? (
          <span>
            <strong>{selectedCount}</strong> selected
          </span>
        ) : (
          <span className="muted">Select rows for bulk actions</span>
        )}
        <div className="bulk-action-bar__selectors">
          {onSelectPage ? (
            <button type="button" className="btn btn-sm btn-ghost" onClick={onSelectPage} disabled={loading}>
              Select page
            </button>
          ) : null}
          {onSelectFiltered && totalFiltered != null ? (
            <button type="button" className="btn btn-sm btn-ghost" onClick={onSelectFiltered} disabled={loading}>
              Select filtered ({totalFiltered})
            </button>
          ) : null}
          {onSelectAll && totalAll != null && totalAll !== totalFiltered ? (
            <button type="button" className="btn btn-sm btn-ghost" onClick={onSelectAll} disabled={loading}>
              Select all ({totalAll})
            </button>
          ) : null}
          {selectedCount > 0 ? (
            <button type="button" className="btn btn-sm btn-ghost" onClick={onClear} disabled={loading}>
              Clear
            </button>
          ) : null}
        </div>
      </div>
      {children ? <div className="bulk-action-bar__actions">{children}</div> : null}
    </div>
  );
}

export type BulkActionButtonProps = React.ComponentProps<typeof LoadingButton>;

export function BulkActionButton(props: BulkActionButtonProps) {
  return <LoadingButton className={['btn-sm', props.className].filter(Boolean).join(' ')} {...props} />;
}
